<app-invoice-grid [gridConfig]="adxInvoiceLineItemsGrid"></app-invoice-grid>